<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogDetail"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >Details du budget pour le projet
            {{ detailChant.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <!--<v-flex xs12  class="text-xs-right" >-->
            <!--<v-btn icons  dark color="orange" @click="imprimerDetail()">Imprimer<v-icon right>print</v-icon></v-btn>-->
            <!--</v-flex>-->
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-card color class="mb-5" flat>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-alert :value="true" outline color="purple" icon="info"
                      >Informations generales sur le projet</v-alert
                    >
                    <v-card flat>
                      <v-layout wrap>
                        <v-card-text>
                          <v-flex xs12>
                            <v-flex xs12 class="text-xs-left">
                              <!--HAUT-->
                              <v-layout row>
                                <v-flex xs6 class="mr-4">
                                  <!--COLONNE 1-->
                                  <v-layout row>
                                    <v-flex xs6>Référence</v-flex>
                                    <v-flex xs6 class="text-xs-right title"
                                      >Projet {{ detailChant.idChant }}</v-flex
                                    >
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Libellé</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.libelle
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <!--<v-layout row>-->
                                  <!--<v-flex xs6>Prix du marché</v-flex>-->
                                  <!--<v-flex xs6 class="text-xs-right title">-->
                                  <!--{{ new Intl.NumberFormat().format(detailChant.mntMarche)}}-->
                                  <!--</v-flex>-->
                                  <!--</v-layout>-->
                                  <!--<v-divider class="mb-3"></v-divider>-->

                                  <v-layout row>
                                    <v-flex xs6>Type de chantier</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.typeChantier
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Date début</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.dateDbt
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Date de fin</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.dateFin
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Situation géographique</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.adresse
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs3>Chef de chantier</v-flex>
                                    <v-flex xs9 class="text-xs-right title">{{
                                      detailChant.responsable
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                </v-flex>

                                <v-flex xs6 class="text-xs-left">
                                  <!--BAS-->

                                  <!--<v-layout row>-->
                                  <!--<v-flex xs6>Maitre d'ouvrage</v-flex>-->
                                  <!--<v-flex xs6 class="text-xs-right title">-->
                                  <!--{{detailChant.maitreOuvrage}}-->
                                  <!--</v-flex>-->
                                  <!--</v-layout>-->
                                  <!--<v-divider class="mb-3"></v-divider>-->
                                  <!--<v-layout row >-->
                                  <!--<v-flex xs6>Architect</v-flex>-->
                                  <!--<v-flex xs6 class="text-xs-right title">-->
                                  <!--{{detailChant.architect}}-->
                                  <!--</v-flex>-->
                                  <!--</v-layout>-->
                                  <!--<v-divider   class="mb-3"></v-divider>-->

                                  <!--<v-layout row>-->
                                  <!--<v-flex xs6>Responsable d'étude </v-flex>-->
                                  <!--<v-flex xs6 class="text-xs-right title">-->
                                  <!--{{detailChant.chefEtude}}-->
                                  <!--</v-flex>-->
                                  <!--</v-layout>-->
                                  <!--<v-divider class="mb-3"></v-divider>-->

                                  <!--<v-layout row>-->
                                  <!--<v-flex xs6>Responsable du contrôle</v-flex>-->
                                  <!--<v-flex xs6 class="text-xs-right title">-->
                                  <!--{{detailChant.chefControle}}-->
                                  <!--</v-flex>-->
                                  <!--</v-layout>-->
                                  <!--<v-divider class="mb-3"></v-divider>-->

                                  <v-layout row>
                                    <v-flex xs6>Budget établi par</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.userCreatedBudget
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Budget validé par</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.userModifiedBudget
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Etat du budget</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.libEtatBudget
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6
                                      >Date d'enregistrement budget</v-flex
                                    >
                                    <v-flex xs6 class="text-xs-right title">{{
                                      detailChant.dateEnregBudget
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>
                        </v-card-text>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-alert :value="true" outline color="purple" icon="info"
                      >Liste du budget travaux à valider</v-alert
                    >

                    <v-layout row>
                      <v-flex xs4>
                        <div class="col-xl-3">
                          <div class="card l-bg-orange-dark">
                            <div class="card-statistic-3 p-4">
                              <div class="card-icon card-icon-large"></div>
                              <div class="mb-4">
                                <h4 class="card-title mb-0">
                                  TOTAL BUDGET PROPOSE
                                </h4>
                              </div>
                              <div class="row  align-items-center mb-2 d-flex">
                                <div class="col-8">
                                  <h1 id="price">
                                    {{
                                      new Intl.NumberFormat().format(
                                        totalMntPropose
                                      )
                                    }}
                                    FCFA
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--
                        <v-chip style="font-size:15px" label outline color="primary">
                          <b>
                            TOTAL BUDGET PROPOSE
                            : {{ new
                            Intl.NumberFormat().format(totalMntPropose)
                            }}
                          </b>
                        </v-chip> -->
                      </v-flex>

                      <v-flex xs4>
                        <div class="col-xl-3 ml-2">
                          <div class="card l-bg-green-dark">
                            <div class="card-statistic-3 p-4">
                              <div class="card-icon card-icon-large"></div>
                              <div class="mb-4">
                                <h4 class="card-title mb-0">
                                  TOTAL BUDGET VALIDE
                                </h4>
                              </div>
                              <div class="row  align-items-center mb-2 d-flex">
                                <div class="col-8">
                                  <h1 id="price">
                                    {{
                                      new Intl.NumberFormat().format(
                                        totalMntValide
                                      )
                                    }}
                                    FCFA
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-flex>

                      <v-flex xs4 class="text-xs-right">
                        <!-- <v-flex xs12 class="text-xs-right"> -->
                        <v-flex>
                          <el-popover
                            ref="popChantier0"
                            placement="top"
                            width="180"
                            trigger="hover"
                          >
                            <p>Veuillez choisir le format d'impression ?</p>
                            <div
                              style="text-align: center; margin: 0;"
                              align="center"
                            >
                              <p align="center">
                                <el-button
                                  type="success"
                                  size="mini"
                                  @click="imprimeBudgtTravauxPDF('PDF')"
                                  >PDF SIMPLE</el-button
                                >
                              </p>
                              <p align="center">
                                <el-button
                                  type="primary"
                                  size="mini"
                                  @click="imprimeBudgtTravauxPDF('PDF')"
                                  >PDF DETAILLE</el-button
                                >
                              </p>
                            </div>
                          </el-popover>
                          <div>
                            <el-button
                              v-popover:popChantier0
                              type="warning"
                              :disabled="disabledBtnPop"
                              icon="el-icon-printer"
                              >Rapport</el-button
                            >
                          </div>
                        </v-flex>
                        <!-- </v-flex> -->
                      </v-flex>
                    </v-layout>

                    <v-card color class="mb-5">
                      <v-card-text>
                        <v-layout wrap>
                          <!--TABLEAU BUDGET PREVISIONNEL-->
                          <v-flex xs12 class="mt-2">
                            <data-tables
                              :data="listeBudget"
                              style="width: 100%"
                            >
                              <!-- debut sous travaux -->
                              <el-table-column type="expand">
                                <template slot-scope="props">
                                  <v-layout
                                    wrap
                                    class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                                  >
                                    <v-flex xs12>
                                      <!-- <span class="title">Liste des Tâches </span> -->
                                      <v-alert
                                        :value="true"
                                        outline
                                        color="primary"
                                        class="mb-4"
                                        icon="info"
                                        >Liste des Tâches</v-alert
                                      >
                                      <v-layout row>
                                        <v-flex xs12 class="mr-2 mt-3">
                                          <div class="grid-content">
                                            <v-flex xs12>
                                              <v-layout row wrap>
                                                <v-flex xs12>
                                                  <el-table
                                                    :data="props.row.taches"
                                                    stripe
                                                    style="width: 100%"
                                                  >
                                                    <el-table-column
                                                      type="expand"
                                                    >
                                                      <template
                                                        slot-scope="props"
                                                      >
                                                        <el-row
                                                          class="elevation-3 pl-4 pr-4 pt-2"
                                                        >
                                                          <el-col :span="24">
                                                            <div
                                                              class="grid-content bg-purple mb-2"
                                                            >
                                                              <v-alert
                                                                :value="true"
                                                                outline
                                                                color="primary"
                                                                class="mb-4"
                                                                icon="info"
                                                                >Détail du
                                                                budget
                                                                travaux</v-alert
                                                              >

                                                              <div>
                                                                <el-table
                                                                  border
                                                                  highlight-current-row
                                                                  :header-row-style="
                                                                    headerRowStyle
                                                                  "
                                                                  :data="
                                                                    props.row
                                                                      .detailBudget
                                                                  "
                                                                  :summary-method="
                                                                    getSummDetailBudget
                                                                  "
                                                                  show-summary
                                                                  style="width: 100%"
                                                                >
                                                                  <el-table-column
                                                                    align="center"
                                                                    prop="libelle"
                                                                    label="DESIGNATION"
                                                                  ></el-table-column>
                                                                  <el-table-column
                                                                    align="center"
                                                                    prop="mntBudgetPropose"
                                                                    label="BUDGET PROPOSE"
                                                                  >
                                                                    <template
                                                                      slot-scope="scope"
                                                                      >{{
                                                                        new Intl.NumberFormat().format(
                                                                          scope
                                                                            .row
                                                                            .montantPropose
                                                                        )
                                                                      }}                                                                     
                                                                  </template
                                                                    >
                                                                  </el-table-column>

                                                                  <el-table-column
                                                                    prop="mntBudgetValide"
                                                                    label="BUDGET VALIDE"
                                                                  >
                                                                    <template
                                                                      slot-scope="prop"
                                                                    >
                                                                      <el-input-number
                                                                        v-if="
                                                                          prop
                                                                            .row
                                                                            .etatBudgetTrx ==
                                                                            0
                                                                        "
                                                                        @change="
                                                                          handleChange
                                                                        "
                                                                        controls-position="right"
                                                                        :min="0"
                                                                        size="small"
                                                                        v-model="
                                                                          prop
                                                                            .row
                                                                            .montantValide
                                                                        "
                                                                      ></el-input-number>
                                                                      <el-tag
                                                                        v-else
                                                                        class="subheading"
                                                                        type="success"
                                                                        >{{
                                                                          new Intl.NumberFormat().format(
                                                                            prop
                                                                              .row
                                                                              .montantValide
                                                                          )
                                                                        }}</el-tag
                                                                      >
                                                                    </template>
                                                                  </el-table-column>

                                                                  <el-table-column
                                                                    prop="ecartBudget"
                                                                    label="ECART MNT BUDGET-PROPOSE"
                                                                    sortable
                                                                  >
                                                                    <template
                                                                      slot-scope="prop"
                                                                    >
                                                                      <v-chip
                                                                        label
                                                                        outline
                                                                        color="primary"
                                                                        >{{
                                                                          prop
                                                                            .row
                                                                            .montantValide -
                                                                            prop
                                                                              .row
                                                                              .montantPropose
                                                                        }}</v-chip
                                                                      >
                                                                    </template>
                                                                  </el-table-column>

                                                                  <el-table-column
                                                                    align="center"
                                                                    sortable
                                                                    prop="periode"
                                                                    label="PERIODE"
                                                                  ></el-table-column>
                                                                </el-table>
                                                              </div>
                                                            </div>
                                                          </el-col>
                                                        </el-row>
                                                      </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                      prop="libelle"
                                                      label="Libellé"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                      <v-chip outline text-color="blue" label> {{ scope.row.libelle }}</v-chip>
                                                      <!-- <span v-for="(item, index) in scope.row.libelle" :key="index">
                                                        <v-chip outline text-color="blue" label> {{ scope.row.libelle }}</v-chip>
                                                      </span>  -->
                                                      </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                      prop="mntBudgetPropose"
                                                      label="MONTANT PROPOSE"
                                                      sortable
                                                      align="center"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <el-tag
                                                          :type="'warning'"
                                                        >
                                                          {{
                                                            new Intl.NumberFormat().format(
                                                              scope.row
                                                                .mntBudgetPropose
                                                            )
                                                          }}
                                                        </el-tag>
                                                      </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                      prop="mntBudgetValide"
                                                      label="MONTANT VALIDE"
                                                      align="center"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <el-tag
                                                        :type="scope.row.mntBudgetValide > 0 ? 'success' : 'danger'"
                                                        >
                                                          {{
                                                            new Intl.NumberFormat().format(
                                                              scope.row
                                                                .mntBudgetValide
                                                            )
                                                          }}
                                                        </el-tag>
                                                      </template>
                                                    </el-table-column>
                                                  </el-table>
                                                </v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </template>
                              </el-table-column>

                              <!-- fin sous travaux -->
                              <!--expand FDFDF-->
                              <!-- <el-table-column type="expand">
                                <template slot-scope="props">
                                  <el-row class="elevation-3 pl-4 pr-4 pt-2">
                                    <el-col :span="24">
                                      <div class="grid-content bg-purple mb-2">
                                        <v-alert
                                          :value="true"
                                          outline
                                          color="primary"
                                          class="mb-4"
                                          icon="info"
                                        >Détail du budget travaux</v-alert>

                                        <div>
                                          <el-table
                                            border
                                            highlight-current-row
                                            :header-row-style="headerRowStyle"
                                            :data="props.row.detailBudget"
                                            :summary-method="getSummDetailBudget"
                                            show-summary
                                            style="width: 100%"
                                          >
                                            <el-table-column
                                              align="center"
                                              prop="libelle"
                                              label="DESIGNATION"
                                            ></el-table-column>
                                            <el-table-column
                                              align="center"
                                              prop="mntBudgetPropose"
                                              label="BUDGET PROPOSE"
                                            >
                                              <template
                                                slot-scope="scope"
                                              >{{new Intl.NumberFormat().format(scope.row.mntBudgetPropose)}}</template>
                                            </el-table-column>

                                            <el-table-column
                                              prop="mntBudgetValide"
                                              label="BUDGET VALIDE"
                                            >
                                              <template slot-scope="prop">
                                                <el-input-number
                                                  v-if="props.row.etatBudgetTrx == 0"
                                                  @change="handleChange"
                                                  controls-position="right"
                                                  :min="0"
                                                  size="small"
                                                  v-model="prop.row.mntBudgetValide"
                                                ></el-input-number>
                                                <el-tag
                                                  v-else
                                                  class="subheading"
                                                  type="success"
                                                >{{ new Intl.NumberFormat().format(prop.row.mntBudgetValide)}}</el-tag>
                                              </template>
                                            </el-table-column>

                                            <el-table-column
                                              prop="ecartBudget"
                                              label="ECART MNT BUDGET-PROPOSE"
                                              sortable
                                            >
                                              <template slot-scope="prop">
                                                <v-chip
                                                  label
                                                  outline
                                                  color="primary"
                                                >{{ prop.row.mntBudgetValide - prop.row.mntBudgetPropose }}</v-chip>
                                              </template>
                                            </el-table-column>

                                            <el-table-column
                                              align="center"
                                              sortable
                                              prop="mois"
                                              label="MOIS"
                                            ></el-table-column>
                                          </el-table>
                                        </div>
                                      </div>
                                    </el-col>
                                  </el-row>
                                </template>
                              </el-table-column> -->
                              <!--expand-->

                              <el-table-column
                                label="Travaux"
                                prop="libelle"
                              ></el-table-column>
                              <el-table-column
                                label="BUDGET PROPOSE"
                                prop="mntTotalBudgetPropose"
                              >
                                <template slot-scope="scope">{{
                                  new Intl.NumberFormat().format(
                                    scope.row.mntTotalBudgetPropose
                                  )
                                }}</template>
                              </el-table-column>

                              <el-table-column
                                label="BUDGET VALIDE"
                                prop="mntTotalBudgetValide"
                              >
                                <template slot-scope="scope">{{
                                  new Intl.NumberFormat().format(
                                    scope.row.mntTotalBudgetValide
                                  )
                                }}</template>
                              </el-table-column>

                              <el-table-column
                                label="ETAT"
                                prop="libEtatBudgetTrx"
                              >
                                <template slot-scope="scope">
                                  <el-tag
                                    class="subheading"
                                    :type="
                                      scope.row.etatBudgetTrx == 1
                                        ? 'success'
                                        : 'danger'
                                    "
                                    >{{ scope.row.libEtatBudgetTrx }}</el-tag
                                  >
                                </template>
                              </el-table-column>
                            </data-tables>
                          </v-flex>
                          <!--TABLEAU BUDGET PREVISIONNEL-->

                          <!--SUIVI BUDGET-->
                          <v-flex xs12 class="mt-4">
                            <v-alert
                              :value="true"
                              outline
                              color="purple"
                              icon="info"
                              >Résultat compte d'exploitation(Affiche uniquement
                              les travaux planifiés par le chef de
                              projet)</v-alert
                            >

                            <!-- INFORMATIONS TAB -->
                            <el-tabs
                              :stretch="true"
                              v-model="compte"
                              type="border-card"
                              @tab-click="handleTabClick(compte)"
                            >
                              <el-tab-pane>
                                <span slot="label">
                                  <v-icon>account_balance</v-icon>Recapitulatif
                                  annuel
                                </span>
                                <v-flex xs12 class="text-xs-right">
                                  <v-flex>
                                    <el-popover
                                      ref="popChantier"
                                      placement="top"
                                      width="180"
                                      trigger="hover"
                                    >
                                      <p>
                                        Veuillez choisir le format d'impression
                                        ?
                                      </p>
                                      <div
                                        style="text-align: center; margin: 0;"
                                        align="center"
                                      >
                                        <p align="center">
                                          <el-button
                                            type="success"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifAnnuelSimpl(
                                                'PDF'
                                              )
                                            "
                                            >PDF SIMPLE</el-button
                                          >
                                        </p>
                                        <p align="center">
                                          <el-button
                                            type="primary"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifAnnuel(
                                                'PDF'
                                              )
                                            "
                                            >PDF DETAILLE</el-button
                                          >
                                        </p>
                                      </div>
                                    </el-popover>
                                    <div>
                                      <el-button
                                        v-popover:popChantier
                                        type="warning"
                                        :disabled="disabledBtnPop"
                                        icon="el-icon-printer"
                                        >Rapport</el-button
                                      >
                                    </div>
                                  </v-flex>
                                </v-flex>
                                <el-collapse accordion>
                                  <v-layout
                                    wrap
                                    class="text-xs-center"
                                    v-for="(groupeMois, index) in bilanMensuel"
                                    :key="index"
                                  >
                                    <div style="width:100%">
                                      <!-- ANNEE -->
                                      <el-collapse-item
                                        :name="index"
                                        style="width:100%"
                                        class="mb-1 pl-3 pr-3"
                                      >
                                        <template slot="title">
                                          <v-layout row>
                                            <v-flex xs4 class="text-sm-left">
                                              <v-chip
                                                dark
                                                label
                                                text-color="white"
                                                style="font-size:20px"
                                                color="purple"
                                              >
                                                <v-icon left>label</v-icon>
                                                {{ index }}
                                              </v-chip>
                                            </v-flex>
                                            <v-flex xs4 class="text-sm-left">
                                              <v-chip
                                                style="font-size:15px"
                                                label
                                                outline
                                                color="primary"
                                              >
                                                <b>
                                                  TOTAL MONTANT PREVU:
                                                  {{
                                                    new Intl.NumberFormat().format(
                                                      groupeMois.totalMntPrevu
                                                    )
                                                  }}
                                                </b>
                                              </v-chip>
                                            </v-flex>
                                            <v-flex xs4 class="text-sm-left">
                                              <v-chip
                                                style="font-size:15px"
                                                label
                                                outline
                                                color="primary"
                                              >
                                                <b>
                                                  TOTAL MONTANT ENGAGÉ:
                                                  {{
                                                    new Intl.NumberFormat().format(
                                                      groupeMois.totalMntDecaisse
                                                    )
                                                  }}
                                                </b>
                                              </v-chip>
                                            </v-flex>
                                          </v-layout>
                                        </template>
                                        <v-flex
                                          xs12
                                          class="mt-3"
                                          v-for="(travaux,
                                          mois) in groupeMois.mois"
                                          :key="mois"
                                        >
                                          <span
                                            style="font-size:20px"
                                            class="blue--text"
                                            >{{ mois }}-{{ index }}</span
                                          >

                                          <el-table
                                            class="elevation-1"
                                            :data="travaux"
                                            highlight-current-row
                                            :header-row-style="headerRowStyle"
                                            style="width: 100%"
                                            border
                                            :summary-method="getSummaries"
                                            show-summary
                                          >
                                            <!--expand-->
                                            <el-table-column type="expand">
                                              <template slot-scope="props">
                                                <el-row
                                                  class="elevation-3 pl-4 pr-4 pt-2"
                                                >
                                                  <el-col :span="24">
                                                    <div
                                                      class="grid-content bg-purple mb-2"
                                                    >
                                                      <v-alert
                                                        :value="true"
                                                        outline
                                                        color="primary"
                                                        class="mb-4"
                                                        icon="info"
                                                        >Liste du budget
                                                        établi</v-alert
                                                      >

                                                      <div>
                                                        <el-table
                                                          border
                                                          highlight-current-row
                                                          :header-row-style="
                                                            headerRowStyle
                                                          "
                                                          :data="
                                                            props.row
                                                              .detailBudget
                                                          "
                                                          :summary-method="
                                                            getSummaries
                                                          "
                                                          show-summary
                                                          style="width: 100%"
                                                        >
                                                          <el-table-column
                                                            align="center"
                                                            prop="libelle"
                                                            label="DESIGNATION"
                                                          ></el-table-column>
                                                          <!-- <el-table-column
                                                                                                                                      align="center"
                                                                                                                                      prop="mntBudgetPropose"
                                                                                                                                      label="BUDGET PROPOSE">
                                                                                                                                  <template slot-scope="scope">
                                                                                                                                      {{new Intl.NumberFormat().format(scope.row.mntBudgetPropose)}}
                                                                                                                                  </template>
                                                        </el-table-column>-->
                                                          <el-table-column
                                                            align="center"
                                                            prop="mntBudgetValide"
                                                            label="BUDGET VALIDE"
                                                          >
                                                            <template
                                                              slot-scope="scope"
                                                              >{{
                                                                new Intl.NumberFormat().format(
                                                                  scope.row
                                                                    .mntBudgetValide
                                                                )
                                                              }}</template
                                                            >
                                                          </el-table-column>

                                                          <el-table-column
                                                            align="center"
                                                            prop="mntProdDecaiss"
                                                            label="MONTANT ENGAGÉ"
                                                          >
                                                            <template
                                                              slot-scope="scope"
                                                            >
                                                              {{
                                                                new Intl.NumberFormat().format(
                                                                  scope.row
                                                                    .mntProdDecaiss
                                                                )
                                                              }}
                                                            </template>
                                                          </el-table-column>
                                                        </el-table>
                                                      </div>
                                                    </div>
                                                  </el-col>
                                                </el-row>
                                              </template>
                                            </el-table-column>
                                            <!--expand-->
                                            <el-table-column
                                              prop="libelle"
                                              align="center"
                                              label="Travaux"
                                            ></el-table-column>

                                            <!-- <el-table-column prop="mntTotalBudgetPropose"  align="center"
                                                                                                                  label="Montant proposé">
                                                                                                      <template
                                                                                                              slot-scope="prop"
                                                                                                      >{{ new
                                                                                                          Intl.NumberFormat().format(prop.row.mntTotalBudgetPropose)}}
                                                                                                      </template>
                                          </el-table-column>-->

                                            <el-table-column
                                              prop="mntTotalBudgetValide"
                                              align="center"
                                              label="Budget validé"
                                            >
                                              <template slot-scope="prop">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    prop.row
                                                      .mntTotalBudgetValide
                                                  )
                                                }}
                                              </template>
                                            </el-table-column>

                                            <el-table-column
                                              align="center"
                                              prop="montantDecaisse"
                                              label="Montant decaissé"
                                            >
                                              <template slot-scope="prop">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    prop.row.montantDecaisse
                                                  )
                                                }}
                                              </template>
                                            </el-table-column>
                                          </el-table>
                                        </v-flex>
                                      </el-collapse-item>
                                      <v-divider class="mb-2"></v-divider>
                                    </div>
                                  </v-layout>
                                </el-collapse>
                              </el-tab-pane>

                              <el-tab-pane>
                                <span slot="label">
                                  <v-icon>library_books</v-icon>Recapitulatif
                                  travaux
                                </span>
                                <v-flex xs12 class="text-xs-right">
                                  <v-flex>
                                    <el-popover
                                      ref="popChantier2"
                                      placement="top"
                                      width="180"
                                      trigger="hover"
                                    >
                                      <p>
                                        Veuillez choisir le format d'impression
                                        ?
                                      </p>
                                      <div
                                        style="text-align: center; margin: 0;"
                                        align="center"
                                      >
                                        <p align="center">
                                          <el-button
                                            type="success"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifTravauxSimpl(
                                                'PDF'
                                              )
                                            "
                                            >PDF SIMPLE</el-button
                                          >
                                        </p>
                                        <p align="center">
                                          <el-button
                                            type="primary"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifTravaux(
                                                'PDF'
                                              )
                                            "
                                            >PDF DETAILLE</el-button
                                          >
                                        </p>
                                      </div>
                                    </el-popover>
                                    <div>
                                      <el-button
                                        v-popover:popChantier2
                                        type="warning"
                                        :disabled="disabledBtnPop"
                                        icon="el-icon-printer"
                                        >Rapport</el-button
                                      >
                                    </div>
                                  </v-flex>
                                </v-flex>
                                <v-layout class="mb-3">
                                  <v-flex xs3>
                                    <div class="col-xl-3">
                                      <div class="card l-bg-orange-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              BUDGET TOTAL VALIDE
                                            </h4>
                                            <h5 id="price">
                                              (Somme des budgets validés)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    bilanTravaux.totalValide
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div class="col-xl-3 ml-2">
                                      <div class="card l-bg-red-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              MONTANT TOTAL ENGAGÉ
                                            </h4>
                                            <h5 id="price">
                                              (Somme des montants décaissés)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    bilanTravaux.totalDecaisse
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div class="col-xl-3 ml-2">
                                      <div class="card l-bg-green-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              ECART BUDGET
                                            </h4>
                                            <h5 id="price">
                                              (Budget validé - Montant
                                              décaissés)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    bilanTravaux.TotalEcart
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <v-chip
                                      color="orange"
                                      style="font-size:19px; width:90%"
                                      text-color="white"
                                    >
                                      <v-avatar class="orange darken-4">
                                        {{ bilanTravaux.totalTravaux }}
                                      </v-avatar>
                                      Lots de travaux
                                    </v-chip>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex xs12>
                                    <v-chip
                                      dark
                                      label
                                      color="purple"
                                      text-color="white"
                                    >
                                      <v-icon left>label</v-icon>
                                      <span>Liste des travaux</span>
                                    </v-chip>

                                    <el-table
                                      border
                                      :header-row-style="headerRowStyle"
                                      highlight-current-row
                                      :data="bilanTravaux.details"
                                      :summary-method="getSumm"
                                      show-summary
                                      style="width: 100%"
                                    >
                                      <el-table-column type="expand">
                                        <template slot-scope="props">
                                          <div>
                                            <v-chip
                                              dark
                                              label
                                              color="purple"
                                              text-color="white"
                                            >
                                              <v-icon left>label</v-icon>
                                              <span>Budget travaux</span>
                                            </v-chip>
                                            <el-table
                                              border
                                              highlight-current-row
                                              :header-row-style="headerRowStyle"
                                              class="elevation-2"
                                              :data="props.row.detailBudget"
                                              :summary-method="getSumm"
                                              show-summary
                                              style="width: 100%"
                                            >
                                              <el-table-column
                                                align="center"
                                                prop="libelle"
                                                sortable
                                                label="DESIGNATION"
                                              >
                                                <template slot-scope="prop">
                                                  <span
                                                    class="subheading black--text"
                                                    >{{
                                                      prop.row.libelle
                                                    }}</span
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="mntRealise"
                                                label="BUDGET VALIDE"
                                              >
                                                <template slot-scope="prop5">
                                                  <el-tag
                                                    class="subheading"
                                                    type="warning"
                                                    >{{
                                                      new Intl.NumberFormat().format(
                                                        prop5.row
                                                          .mntBudgetValide
                                                      )
                                                    }}</el-tag
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                prop="mntProdDecaiss"
                                                label="MONTANT ENGAGÉ"
                                              >
                                                <template slot-scope="scope">
                                                  {{
                                                    new Intl.NumberFormat().format(
                                                      scope.row.mntProdDecaiss
                                                    )
                                                  }}
                                                </template>
                                              </el-table-column>

                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="ecart"
                                                label="ECART"
                                              >
                                                <template slot-scope="prop3">
                                                  <el-tag
                                                    class="subheading"
                                                    :type="
                                                      prop3.row.ecart < 0
                                                        ? 'danger'
                                                        : 'success'
                                                    "
                                                    >{{
                                                      new Intl.NumberFormat().format(
                                                        prop3.row.ecart
                                                      )
                                                    }}</el-tag
                                                  >
                                                </template>
                                              </el-table-column>
                                            </el-table>
                                          </div>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="libelle"
                                        label="DESIGNATION"
                                      >
                                        <template slot-scope="prop">
                                          <span
                                            class="subheading black--text"
                                            >{{ prop.row.libelle }}</span
                                          >
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="mntTotalBudgetValide"
                                        label="BUDGET VALIDE"
                                      >
                                        <template slot-scope="prop5">
                                          <el-tag
                                            class="subheading"
                                            type="warning"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop5.row.mntTotalBudgetValide
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="mntTotalTypeTrxDecaisse"
                                        label="MONTANT ENGAGÉ"
                                      >
                                        <template slot-scope="prop5">
                                          <el-tag
                                            class="subheading"
                                            type="warning"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop5.row
                                                  .mntTotalTypeTrxDecaisse
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="ecart"
                                        label="ECART"
                                      >
                                        <template slot-scope="prop3">
                                          <el-tag
                                            class="subheading"
                                            :type="
                                              prop3.row.ecart < 0
                                                ? 'danger'
                                                : 'success'
                                            "
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop3.row.ecart
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>
                                    </el-table>
                                  </v-flex>
                                </v-layout>
                              </el-tab-pane>

                              <el-tab-pane>
                                <span slot="label">
                                  <v-icon>account_balance_wallet</v-icon>Etat
                                  financier
                                </span>
                                <v-flex xs12 class="text-xs-right">
                                  <v-flex>
                                    <el-popover
                                      ref="popChantier3"
                                      placement="top"
                                      width="180"
                                      trigger="hover"
                                    >
                                      <p>
                                        Veuillez choisir le format d'impression
                                        ?
                                      </p>
                                      <div
                                        style="text-align: center; margin: 0;"
                                        align="center"
                                      >
                                        <p align="center">
                                          <el-button
                                            type="success"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifFinanceSimpl(
                                                'PDF'
                                              )
                                            "
                                            >PDF SIMPLE</el-button
                                          >
                                        </p>
                                        <p align="center">
                                          <el-button
                                            type="primary"
                                            size="mini"
                                            @click="
                                              imprimeBudgtRecapitulatifFinance(
                                                'PDF'
                                              )
                                            "
                                            >PDF DETAILLE</el-button
                                          >
                                        </p>
                                      </div>
                                    </el-popover>
                                    <div>
                                      <el-button
                                        v-popover:popChantier3
                                        type="warning"
                                        :disabled="disabledBtnPop"
                                        icon="el-icon-printer"
                                        >Rapport</el-button
                                      >
                                    </div>
                                  </v-flex>
                                </v-flex>
                                <v-layout class="mb-3">
                                  <v-flex xs3>
                                    <div class="col-xl-3">
                                      <div class="card l-bg-orange-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              TOTAL DES FACTURES
                                            </h4>
                                            <h5 id="price">
                                              (Somme de toutttes les factures)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    listeDetail.total
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div class="col-xl-3 ml-2">
                                      <div class="card l-bg-green-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              TOTAL DES FACTURES PAYEES
                                            </h4>
                                            <h5 id="price">
                                              (Somme de toutes les factures
                                              payées)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    listeDetail.totalPaye
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div class="col-xl-3 ml-2">
                                      <div class="card l-bg-red-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              TOTAL DES FACTURES IMPAYEES
                                            </h4>
                                            <h5 id="price">
                                              (Sommes de toutes les factures
                                              impayées)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    listeDetail.totalImpaye
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div
                                      class="col-xl-3 ml-2"
                                      v-if="listeDetail.ecart <= 0"
                                    >
                                      <div class="card l-bg-red-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              TOTAL ECART BUDGET
                                            </h4>
                                            <h5 id="price">
                                              (Budget validé - Total des
                                              factures)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    totalMntValide -
                                                      listeDetail.totalPaye
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="col-xl-3 ml-2"
                                      v-if="listeDetail.ecart > 0"
                                    >
                                      <div class="card l-bg-green-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              TOTAL ECART BUDGET
                                            </h4>
                                          </div>
                                          <div
                                            class="row align-items-center mb-2 d-flex"
                                          >
                                            <div class="card col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    listeDetail.ecart
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex xs3>
                                    <div class="col-xl-3 ml-2">
                                      <div
                                        v-if="
                                          totalMntValide - listeDetail.total > 0
                                        "
                                        class="card l-bg-green-dark"
                                      >
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              MARGE REELLE
                                            </h4>
                                            <h5 id="price">
                                              (Montant marché - Total des
                                              factures payées)
                                            </h5>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    totalMntValide -
                                                      listeDetail.total
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        v-if="
                                          totalMntValide - listeDetail.total < 0
                                        "
                                        class="card l-bg-red-dark"
                                      >
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              MARGE REELLE
                                            </h4>
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    totalMntValide -
                                                      listeDetail.total
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>

                                  <v-flex xs3 v-if="mntTotalChargeI > 0">
                                    <div class="col-xl-3 ml-2">
                                      <div class="card l-bg-red-dark">
                                        <div class="card-statistic-3 p-4">
                                          <div class="mb-4">
                                            <h4 class="card-title mb-0">
                                              MONTANT TOTAL CHARGE INDIRECT
                                            </h4>
                                            <!-- <h5 id="price">(M)</h5> -->
                                          </div>
                                          <div
                                            class="row  align-items-center mb-2 d-flex"
                                          >
                                            <div class="col-8">
                                              <h1 id="price">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    mntTotalChargeI
                                                  )
                                                }}
                                                FCFA
                                              </h1>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <!-- MODAL CHARGE INDIRECT -->
                                <v-card-text
                                  v-if="listChargeResult.length != 0"
                                >
                                  <v-chip
                                    dark
                                    label
                                    color="purple"
                                    text-color="white"
                                  >
                                    <v-icon left>label</v-icon>
                                    <span>DETAILS DES CHARGES INDIRECT</span>
                                  </v-chip>

                                  <el-table
                                    border
                                    :header-row-style="headerRowStyle"
                                    highlight-current-row
                                    :data="listChargeResult"
                                    :summary-method="getSummCompte"
                                    show-summary
                                    style="width: 100%"
                                  >
                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="type"
                                      label="TYPE"
                                    >
                                      <template slot-scope="prop">
                                        <span class="subheading black--text">{{
                                          prop.row.type
                                        }}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="produit"
                                      label="DESIGNATION"
                                    >
                                      <template slot-scope="prop">
                                        <span class="subheading black--text">{{
                                          prop.row.produit
                                        }}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="unite"
                                      label="UNITE"
                                    >
                                      <template slot-scope="prop">
                                        <span class="subheading black--text">{{
                                          prop.row.unite
                                        }}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="periode"
                                      label="Période"
                                      align="center"
                                      width="190px"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          v-if="scope.row.periode == 'tous'"
                                          text-color="white"
                                          color="orange"
                                          >APPLIQUER A TOUT LE PROJET</v-chip
                                        >
                                        <v-chip
                                          v-else
                                          text-color="white"
                                          color="orange"
                                          >SUR UNE PERIODE</v-chip
                                        >
                                        <v-chip
                                          v-if="scope.row.periode != 'tous'"
                                          text-color="white"
                                          color="primary"
                                          >{{ scope.row.dateD }} AU
                                          {{ scope.row.dateF }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="qte"
                                      label="QUANTITE"
                                    >
                                      <template slot-scope="prop">
                                        <el-tag
                                          class="subheading"
                                          type="warning"
                                          >{{
                                            new Intl.NumberFormat().format(
                                              prop.row.qte
                                            )
                                          }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="cout"
                                      label="PRIX UNITAIRE"
                                    >
                                      <template slot-scope="prop">
                                        <el-tag
                                          class="subheading"
                                          type="warning"
                                          >{{
                                            new Intl.NumberFormat().format(
                                              prop.row.cout
                                            )
                                          }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="total"
                                      label="TOTAL"
                                    >
                                      <template slot-scope="prop">
                                        <el-tag
                                          class="subheading"
                                          type="warning"
                                          >{{
                                            new Intl.NumberFormat().format(
                                              prop.row.total
                                            )
                                          }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </v-card-text>
                                <br />
                                <br />
                                <v-layout
                                  row
                                  v-for="(compte, index) in listeDetail.details"
                                  :key="index"
                                  class="mt-3 mb-4"
                                >
                                  <v-flex xs12>
                                    <v-chip
                                      dark
                                      label
                                      color="purple"
                                      text-color="white"
                                    >
                                      <v-icon left>label</v-icon>
                                      <span>{{ index }}</span>
                                    </v-chip>

                                    <el-table
                                      class="mb-4"
                                      border
                                      highlight-current-row
                                      :header-row-style="headerRowStyle"
                                      :data="compte"
                                      :summary-method="getSummCompteFinance"
                                      show-summary
                                      style="width: 100%"
                                    >
                                      <el-table-column type="expand">
                                        <template slot-scope="propsArticle">
                                          <el-row
                                            class="elevation-3 pl-4 pr-4 pt-2"
                                          >
                                            <el-col :span="24">
                                              <div
                                                class="grid-content bg-purple"
                                              >
                                                <v-chip
                                                  dark
                                                  label
                                                  color="purple"
                                                  text-color="white"
                                                >
                                                  <v-icon left>label</v-icon>
                                                  <span>Détails facture</span>
                                                </v-chip>

                                                <el-table
                                                  border
                                                  highlight-current-row
                                                  :header-row-style="
                                                    headerRowStyle
                                                  "
                                                  :data="
                                                    propsArticle.row.produits
                                                  "
                                                  :summary-method="getSummaries"
                                                  show-summary
                                                  style="width: 100%"
                                                >
                                                  <el-table-column
                                                    prop="ref"
                                                    align="center"
                                                    label="REFERENCE"
                                                  ></el-table-column>
                                                  <el-table-column
                                                    prop="designation"
                                                    align="center"
                                                    label="DESIGNATION"
                                                  ></el-table-column>
                                                  <el-table-column
                                                    prop="qte"
                                                    align="center"
                                                    label="QUANTITE"
                                                  >
                                                    <template
                                                      slot-scope="propA1"
                                                    >
                                                      {{
                                                        new Intl.NumberFormat().format(
                                                          propA1.row.qte
                                                        )
                                                      }}
                                                    </template>
                                                  </el-table-column>

                                                  <el-table-column
                                                    prop="unite"
                                                    align="center"
                                                    label="UNITE"
                                                  ></el-table-column>
                                                  <el-table-column
                                                    prop="prixU"
                                                    align="center"
                                                    label="PRIX UNITAIRE"
                                                  >
                                                    <template
                                                      slot-scope="propA2"
                                                    >
                                                      {{
                                                        new Intl.NumberFormat().format(
                                                          propA2.row.prixU
                                                        )
                                                      }}
                                                    </template>
                                                  </el-table-column>

                                                  <el-table-column
                                                    prop="tva"
                                                    align="center"
                                                    label="TVA"
                                                  ></el-table-column>
                                                  <el-table-column
                                                    prop="remise"
                                                    label="REMISE"
                                                    align="center"
                                                  ></el-table-column>
                                                  <el-table-column
                                                    prop="total"
                                                    align="center"
                                                    label="TOTAL"
                                                  >
                                                    <template
                                                      slot-scope="propA3"
                                                    >
                                                      <el-tag
                                                        class="subheading"
                                                        type="warning"
                                                      >
                                                        {{
                                                          new Intl.NumberFormat().format(
                                                            propA3.row.total
                                                          )
                                                        }}
                                                      </el-tag>
                                                    </template>
                                                  </el-table-column>

                                                  <el-table-column
                                                    prop="mntBudgetValide"
                                                    align="center"
                                                    label="Budget matériel validé"
                                                  >
                                                    <template slot-scope="prop">
                                                      <el-tag
                                                        class="subheading"
                                                        type="warning"
                                                      >
                                                        {{
                                                          new Intl.NumberFormat().format(
                                                            prop.row
                                                              .mntBudgetValide
                                                          )
                                                        }}
                                                      </el-tag>
                                                    </template>
                                                  </el-table-column>
                                                </el-table>
                                              </div>
                                            </el-col>
                                          </el-row>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        sortable
                                        align="center"
                                        prop="ref"
                                        label="REFERENCE"
                                      >
                                        <template slot-scope="prop">
                                          <span
                                            class="subheading black--text"
                                            >{{ prop.row.ref }}</span
                                          >
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="designation"
                                        label="DESIGNATION"
                                      ></el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="total"
                                        label="TOTAL FACTURE"
                                      >
                                        <template slot-scope="prop2">
                                          <el-tag
                                            class="subheading"
                                            type="warning"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop2.row.total
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="totalPaye"
                                        label="TOTAL FACTURE PAYEE"
                                      >
                                        <template slot-scope="prop2">
                                          <el-tag
                                            class="subheading"
                                            type="success"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop2.row.totalPaye
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="totalImpaye"
                                        label="TOTAL FACTURE IMPAYEE"
                                      >
                                        <template slot-scope="prop2">
                                          <el-tag
                                            class="subheading"
                                            type="danger"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop2.row.totalImpaye
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="mntTotalBudgetValide"
                                        label="BUDGET PRODUIT VALIDE"
                                      >
                                        <template slot-scope="prop">
                                          <el-tag
                                            class="subheading"
                                            type="info"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop.row.mntTotalBudgetValide
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="ecart"
                                        label="ECART BUDGET-TOTAL FACTURE"
                                      >
                                        <template slot-scope="prop3">
                                          <el-tag
                                            class="subheading"
                                            :type="
                                              prop3.row.ecart < 0
                                                ? 'danger'
                                                : 'success'
                                            "
                                            >{{
                                              new Intl.NumberFormat().format(
                                                prop3.row.ecart
                                              )
                                            }}</el-tag
                                          >
                                        </template>
                                      </el-table-column>
                                    </el-table>
                                  </v-flex>
                                </v-layout>
                              </el-tab-pane>
                            </el-tabs>
                          </v-flex>
                          <!--SUIVI BUDGET-->
                        </v-layout>
                      </v-card-text>
                    </v-card>

                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>

      <v-tooltip top>
        <v-btn
          v-if="detailChant.etat == false && listeBudget.length > 0"
          class="mb-5"
          style="margin-right: 100px"
          absolute
          slot="activator"
          dark
          fab
          large
          bottom
          right
          color="success"
          @click="dialogConfirm = true"
        >
          <v-icon>done</v-icon>
        </v-btn>
        <span>Valider le budget</span>
      </v-tooltip>
    </v-dialog>
    <!-- CONFIRMATION VALIDATION -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogConfirm" persistent max-width="650">
        <v-card>
          <v-card-title class="headline"
            >Validation du budget du projet
            {{ detailChant.libelle }}</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 class="mb-2">
                <el-alert
                  title="Voulez vous valider le budget  ?"
                  :closable="false"
                  show-icon
                  type="success"
                ></el-alert>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              dark
              @click.native="dialogConfirm = false"
              >Annuler</v-btn
            >
            <v-btn
              color="green darken-1"
              dark
              @click.native="SubmitValideBudget()"
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<style>
.card {
  background-color: #fff;
  border-radius: 10px;
  border: none;
  position: relative;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 30px;
  box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1),
    0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1),
    0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12),
    0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);
}
#appercu {
  position: absolute;
  top: 15px;
  left: 40px;
  display: none;
  width: 40px;
  height: 20px;
}
.card h4:hover {
  display: block;
}

#price {
  border: none;
  position: relative;
  margin: 0 auto;
  text-align: center;
}

.l-bg-cherry {
  background: linear-gradient(to right, #493240, #f09) !important;
  color: #fff;
}

.l-bg-blue-dark {
  background: linear-gradient(to right, #373b44, #4286f4) !important;
  color: #fff;
}

.l-bg-green-dark {
  background: linear-gradient(to right, #0a504a, #38ef7d) !important;
  color: #fff;
}

.l-bg-red-dark {
  background: linear-gradient(to right, #c71111, #ffba56) !important;
  color: #fff;
}
.l-bg-orange-dark {
  background: linear-gradient(to right, #a86008, #ffba56) !important;
  color: #fff;
}

.card .card-statistic-3 .card-icon-large .fas,
.card .card-statistic-3 .card-icon-large .far,
.card .card-statistic-3 .card-icon-large .fab,
.card .card-statistic-3 .card-icon-large .fal {
  font-size: 110px;
}

.card .card-statistic-3 .card-icon {
  text-align: center;
  line-height: 50px;
  margin-left: 15px;
  color: #000;
  position: absolute;
  right: -5px;
  top: 20px;
  opacity: 0.1;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}

.l-bg-green {
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
  color: #fff;
}

.l-bg-orange {
  background: linear-gradient(to right, #f9900e, #ffba56) !important;
  color: #fff;
}

.l-bg-red {
  background: linear-gradient(to right, #c71111, #ffba56) !important;
  color: #fff;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}
</style>
<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "DetailBudgetChant",
  props: {
    show: {
      type: Boolean
    },
    detailChant: {
      type: Object
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      listeBudget: [],
      detailsBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      compte: "0",
      listChargeResult: [],
      mntTotalChargeI: 0,
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0,
      totalMntantTravaux: 0
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        this.loadDetails(this.detailChant.idChant);
        this.loadBilan(this.detailChant.idChant);
      }
    }
  },

  methods: {
    handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        const values = data.map(item => Number(item[column.property]));

        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        this.totalMntantTravaux = 0;
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });
      this.totalMntantTravaux = sums;
      return sums;
    },
    closeDialog() {
      this.$emit("close");
    },
    getSummCompte(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummCompteFinance(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    handleChange(newValue, oldValue) {},
    SubmitValideBudget() {
      this.loading = true;
      let url = this.domaine + "compteExploit/valider/budget_chantier";
      let data = new FormData();
      let etat = false;

      for (let j = 0; j < this.listeBudget.length; j++) {
        this.listeBudget.forEach(item => {          

          item["taches"].forEach(element=> {

              let liste = element["detailBudget"];

              let nbData = 10;
              let nbReq = 1;
              let ligne = null;
              let details = null;
              let nbRest;
              if (liste.length > 10) {
                nbData = 10;
                nbReq = Math.round(liste.length / nbData);
                nbRest = liste.length % nbData;
                if (nbRest > 0) {
                  nbReq += 1;
                }
              }
              for (let i = 0; i < nbReq; i++) {
                let initJ = i * nbData;
                let finJ = (i + 1) * nbData;
                let dataLot = [];
                
                if (liste.length > 0) {
                  for (let j = initJ; j < finJ; j++) {
                    if (liste[j] == undefined) {
                      break;
                    }
                    dataLot.push(liste[j]);

                    // if( liste[j]['etat'] === 0) {
                    //   dataLot.push(liste[j]);
                    // }
                  }

                  let data = new FormData();
                    for (let prop in dataLot) {
                      details = dataLot[prop];
                      data.append("option[idBudget][]", details.idBudget);
                      // data.append("option[libelle][]", details.libelle);
                      // data.append("option[mntBudgetPropose][]",details.montantPropose);
                      data.append("option[mntBudgetValide][]", details.montantValide);             
                    }

                    data.append("idUser", this.user.id);
                    data.append("idChantier", this.detailChant.idChant);
                    this.$http.post(url, data).then(
                      resp => {
                        this.loading = false;
                        this.dialogConfirm = false
                      // this.closeDialog();
                      },
                      error => {
                        this.loading = false;
                        this.$message.error(
                          "Erreur lors de l'enregistrement des tarifs"
                        );
                      }
                    );
                }
              }
          })
         
        });
      }
      this.closeDialog();
      this.dialogConfirm = false;
      this.loading = false;
      4591

      this.$notify({
        title: "VALIDATION BUDGET",
        message: "l'operation c'est déroulé avec succès",
        type: "success",
        position: "top-right",
        duration: 5000
      });
      this.closeDialog();
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    getSummDetailBudget(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        // if (index === 5) {
        //   sums[index] = "N/A";
        //   return;
        // }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummCompte(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    loadDetails(idChant) {
      this.loading = true;
      let url = this.domaine + "compteExploit/budget/chantier/" + idChant;
      this.$http.get(url).then(
        resp => {
          this.loading = false;
          this.detailsBudget = resp.body.budgetsChantier;
          this.listeBudget = resp.body.budgetsChantier;
          this.totalMntPropose = 0;
          this.totalMntValide = 0;
          this.totalMntMarche = 0;
          this.listeBudget.forEach(item => {
            this.totalMntPropose += item.mntTotalBudgetPropose;
            this.totalMntValide += item.mntTotalBudgetValide;
          });

          // this.totalMntPropose = resp.body.mntTotalBugPropose;
          // this.totalMntValide = resp.body.mntTotalBugValide;
          //this.totalMntMarche = resp.body.mntTotalBugMarche;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement des budget"
          );
        }
      );
    },
    loadBilan(idChant) {
      this.loading = true;
      let url = this.domaine + "budgetChantier/bilan/chantier/" + idChant;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.bilanMensuel = response.body.mensuel;
          this.bilanTravaux = response.body.bilanTravaux.travaux;
          this.listeDetail = response.body.detailCompte;
          this.listChargeResult = response.body.chargesIn;

          this.mntTotalChargeI = response.body.totalChargeI;
          // this.totalMntPropose = 0;
          // this.totalMntValide = 0;
          // this.totalMntMarche = 0;
          // this.bilanTravaux.details.forEach(item => {
          //   this.totalMntPropose += item.mntTotalBudgetPropose;
          //   this.totalMntValide += item.mntTotalBudgetValide;
          // });
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement du bilan"
          );
        }
      );
    },
    imprimeBudgtTravauxPDF(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_budget_travaux";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_budget_travaux";
      }
      window.open(url);
    },
    imprimeBudgtTravauxPDFSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_budget_travauxSimpl";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_budget_travauxSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuel(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifAnnuel";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifAnnuel";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuelSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifAnnuelSimpl";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifAnnuelSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravaux(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifTravaux";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifTravaux";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravauxSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifTravauxSimpl";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifTravauxSimpl";
      }
      window.open(url);
    },

    imprimeBudgtRecapitulatifFinance(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifFinancier";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifFinancier";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifFinanceSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifFinancierSimpl";
      } else {
        url =
          this.domaine +
          "budgetChantier/budget/chantier/" +
          this.detailChant.idChant +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifFinancierSimpl";
      }
      window.open(url);
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/chantier/DetailBudgetChant.vue